(function ($) {

  const headerButtonModalStoreLocator = document.querySelector('#openHeaderStoreLocationDropdownButton');
  const siteDimmer = document.querySelector('[data-site-main-dimmer]');

  // remove Dimmer
  function onModalCloseClick() {
    siteDimmer.setAttribute('data-animation-state', 'closed');
  }

  const modals = document.querySelectorAll('[data-modal]');

  modals.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {

      event.preventDefault();

      const modal = document.getElementById(trigger.dataset.modal);
      modal.classList.toggle('open');

      const exits = modal.querySelectorAll('.modal-exit');

      exits.forEach(function (exit) {
        exit.addEventListener('click', function (event) {
          event.preventDefault();
          modal.classList.remove('open');
            // set Open-Button on inactive
            headerButtonModalStoreLocator.classList.remove('active')
            // remove dimmer
            onModalCloseClick();
        });
      });
    });
  });

})(jQuery);

(async function ($) {

  const SELECTED_STORE_ID_COOKIE_STORAGE_KEY = "SELECTED_STORE_ID_COOKIE_STORAGE_KEY";
  const SELECTED_STORE_TITLE_COOKIE_STORAGE_KEY = "SELECTED_STORE_TITLE_COOKIE_STORAGE_KEY";
  const UTM_STORE_ID_PARAMETER_KEY = "utm_store_id";
  const UTM_STORE_TITLE_PARAMETER_KEY = "utm_store_title";

  var storeIdUtmParameter = null,
      storeTitleUtmParameter = null,
      selectedStore = await getUpdateCurrentSelectedStoreInformation(),
      customerLoggedIn = !!customerId;
      showStoreContent = false;

  const assignedStoreInput = document.querySelector('#header_assigned_store');
  const assignedStoreHeaderButton = document.querySelector('#header_store_locator_cta');
  var originalAssignedStoreHeaderButtonContent = assignedStoreHeaderButton.textContent;

  const assignedStoreIdInput = document.querySelector('#header_assigned_store_id');
  const updateSelectedStore = document.querySelector('#header_updateSelectedStore');
  const registerStoreSelectionList = document.querySelector('#header_selectionStoresList');
  const headerNoStoreSelectedContent = document.querySelector('#header_no-store-selected-content');
  const headerNoStoreSelectedHeadline = document.querySelector('#header_no-store-selected-headline');
  const headerNoStoreSelectedLoader = document.querySelector('#header_no-store-selected-loader');
  const headerNoStoreSelectedInputLabel = document.querySelector('#header_no-store-selected-inputlabel');
  const headerModalStoreLocator = document.querySelector('#modal-store-locator');
  const headerStoreLocatorFormInnerHTML = document.querySelector('#header-store-locator-form-inner');
  const headerButtonModalStoreLocator = document.querySelector('#openHeaderStoreLocationDropdownButton');
  const headerCloseButtonModalStoreLocator = document.querySelector('.header-store-locator-container .modal-exit');
  const siteDimmer = document.querySelector('[data-site-main-dimmer]');
  const headerSection = document.querySelector('#shopify-section-static-header-custom');
  const modalInnerContainer = document.querySelector('#modal-store-locator--inner-container');

  if (typeof (assignedStoreInput) != 'undefined' && assignedStoreInput != null) {
    assignedStoreInput.addEventListener('focus', toggleList);
    assignedStoreInput.addEventListener('focusout', hideList);
    assignedStoreInput.addEventListener('keydown', onAssignedStoreInputKeydown);
    assignedStoreInput.addEventListener('input', onRegisterAssignedStoreInputChange);
  }

  if (typeof (updateSelectedStore) != 'undefined' && updateSelectedStore != null) {
    updateSelectedStore.addEventListener('click', onUpdateSelectedStore);
  }

  headerButtonModalStoreLocator.addEventListener('click', function (event) {
    setButtonStateAndDimmer();
  });

  headerCloseButtonModalStoreLocator.addEventListener('click', onModalCloseClick);

  function onModalCloseClick() {
    siteDimmer.setAttribute('data-animation-state', 'closed');
  }

  function onModalOpenClick() {
    siteDimmer.setAttribute('data-animation-state', 'open');
  }

  function loadSelectableStores() {
    if (selectedStore.selectedStoreId !== "") {
      preselectStore();
    }

    $.get({
      url: encodeURI(`${storeLocatorApiUrl}/locatorselectable`),
      method: 'POST',
      data: JSON.stringify({
        sessionId: storeLocatorSessionId
      }),
      success: function (response) {
        const data = response;
        const stores = data.stores;

        stores.forEach(store => {
          const element = document.createElement('li');
          element.classList.add('stores-selection-list-entry', 'dropdown-item');
          element.textContent = store.title + ", " + store.street + " " + store.number + " " + store.zipcode + " " + store.city;
          element.setAttribute('data-store-id', store.id);
          element.setAttribute('data-store-short-description', store.title + ", " + store.zipcode + " " + store.city);

          element.addEventListener('click', onStoreSelectionClick);

          registerStoreSelectionList.appendChild(element);
        });
      }
    });
  }

  function preselectStore() {
    selectedStore = getCurrentSelectedStoreInformation();
    assignedStoreInput.value = selectedStore.selectedStoreTitle;
    assignedStoreIdInput.value = "selectedStore:" + selectedStore.selectedStoreId;
    assignedStoreInput.disabled = true;
    updateSelectedStore.classList.remove('d-none');
    headerNoStoreSelectedContent.classList.add('d-none');
    headerNoStoreSelectedHeadline.classList.add('d-none');
    headerNoStoreSelectedLoader.classList.remove('d-none');
    headerNoStoreSelectedInputLabel.classList.add('d-none');
    headerModalStoreLocator.classList.add('nf-store-is-selected');
    headerStoreLocatorFormInnerHTML.classList.remove('col');
    headerStoreLocatorFormInnerHTML.classList.add('col-12','col-lg-6');

    /**
     * Header Store Locator Dropdown Button
     * @type {string|string}
     */
    assignedStoreHeaderButton.textContent = selectedStore.selectedStoreTitle;

    /**
     * Show My preselected Store Content
     */
    showMySelectedStoreContent(selectedStore.selectedStoreId);
  }

  function onStoreSelectionClick(event) {
    const currentElement = event.currentTarget;
    const selectedStoreId = currentElement.getAttribute('data-store-id');
    const selectedStoreText = currentElement.getAttribute('data-store-short-description');

    persistSelectedStoreInformationLocal(selectedStoreId, selectedStoreText);
    persistSelectedStoreInformationGlobal(selectedStoreId);
    setSelectedStore(selectedStoreId, selectedStoreText);
    assignedStoreHeaderButton.textContent = selectedStoreText;
    headerNoStoreSelectedInputLabel.classList.add('d-none');
    headerModalStoreLocator.classList.add('nf-store-is-selected');
    headerStoreLocatorFormInnerHTML.classList.add('col-12','col-lg-6');
    showMySelectedStoreContent(selectedStoreId);

    const updateStoreRegistrationFormEvent = new Event('updateStoreRegistrationForm');
    document.dispatchEvent(updateStoreRegistrationFormEvent);
  }

  function setSelectedStore(selectedStoreId, selectedStoreTitle) {
    assignedStoreInput.value = selectedStoreTitle;
    assignedStoreIdInput.value = "selectedStore:" + selectedStoreId;
    assignedStoreInput.disabled = true;
    updateSelectedStore.classList.remove('d-none');

    toggleList();
  }

  function onUpdateSelectedStore() {
    assignedStoreInput.disabled = false;
    assignedStoreInput.value = "";
    assignedStoreIdInput.value = "";
    this.classList.add('d-none');

    const storeListEntries = document.querySelectorAll('.stores-selection-list-entry');
    storeListEntries.forEach(storeListEntry => storeListEntry.classList.remove('d-none'));
  }

  function onRegisterAssignedStoreInputChange() {
    const storeListEntries = document.querySelectorAll('.stores-selection-list-entry');
    const currentInput = this.value;

    storeListEntries.forEach(storeListEntry => {
      if (!storeListEntry.textContent.toLowerCase().replace('®', '')
          .includes(currentInput.toLowerCase().replace('®', ''))) {
        storeListEntry.classList.add('d-none');
      } else {
        storeListEntry.classList.remove('d-none');
      }
    })
  }

  function getCurrentSelectedStoreInformation() {
    const selectedStoreId = getCookie(SELECTED_STORE_ID_COOKIE_STORAGE_KEY),
        selectedStoreTitle = getCookie(SELECTED_STORE_TITLE_COOKIE_STORAGE_KEY);

    return {selectedStoreId, selectedStoreTitle};
  }

  async function getUpdateCurrentSelectedStoreInformation() {
    let selectedStoreId = getCookie(SELECTED_STORE_ID_COOKIE_STORAGE_KEY),
        selectedStoreTitle = getCookie(SELECTED_STORE_TITLE_COOKIE_STORAGE_KEY);

    if ((typeof (storeId) != 'undefined' && storeId != null && storeId !== "")
        && ((typeof (selectedStoreId) == 'undefined' || selectedStoreId == null || selectedStoreId === "")
            || (typeof (selectedStoreTitle) == 'undefined' || selectedStoreTitle == null || selectedStoreTitle === "")
            || (storeId !== selectedStoreId))) {
      selectedStoreId = storeId;

      await $.get({
        url: encodeURI(`${storeLocatorApiUrl}/locatorselectable`),
        method: 'POST',
        data: JSON.stringify({
          sessionId: storeLocatorSessionId
        }),
        success: function (response) {
          const stores = response.stores

          stores.forEach(store => {
            if (store.id + "" === storeId) {
              selectedStoreTitle = store.title
              document.querySelector('#header_store_locator_cta').textContent = store.title;
            }
          });

          persistSelectedStoreInformationLocal(selectedStoreId, selectedStoreTitle);
        }
      });

    }

    return {selectedStoreId, selectedStoreTitle};
  }

  function persistSelectedStoreInformationLocal(selectedStoreId, selectedStoreTitle) {
    setCookie(SELECTED_STORE_ID_COOKIE_STORAGE_KEY, selectedStoreId);
    setCookie(SELECTED_STORE_TITLE_COOKIE_STORAGE_KEY, selectedStoreTitle);
  }

  function persistSelectedStoreInformationGlobal(selectedStoreId) {
    fetch(`${storeLocatorApiUrl}/locator/store-select`, {
      method: "POST",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        sessionId: storeLocatorSessionId,
        selectedStoreId: selectedStoreId,
        customerId
      })
    });
  }

  function setCookie(name, value, expireDays) {
    const d = new Date();
    let expires = "";
    if (expireDays) {
      d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
      expires = "expires=" + d.toUTCString();
    }

    if(!value || value === "" || value === "not set") {
      expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function toggleList() {
    document.querySelector('#header_selectionStoresList').classList.toggle('d-none');
  }

  function hideList() {
    window.setTimeout(() => {
      document.querySelector('#header_selectionStoresList').classList.add('d-none');
    }, 500);
  }

  if (typeof (registerStoreSelectionList) != 'undefined' && registerStoreSelectionList != null) {
    loadSelectableStores();
  }

  function showMySelectedStoreContent(selectedStoreId) {
    headerNoStoreSelectedContent.classList.add('d-none');
    headerNoStoreSelectedHeadline.classList.add('d-none');

    var settings = {
      "url": `${storeLocatorApiUrl}/locator/store/` + selectedStoreId,
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json"
      },
      "data": JSON.stringify({
        "sessionId": storeLocatorSessionId
      }),
    };

    $.ajax(settings).done(function (response) {
      document.getElementById("store-content").innerHTML = response.template
    });
  }

  function hideMySelectedStoreContent() {
    document.getElementById("store-content").innerHTML = "";

    headerNoStoreSelectedContent.classList.remove('d-none');
    headerNoStoreSelectedHeadline.classList.remove('d-none');
    headerNoStoreSelectedInputLabel.classList.remove('d-none');
    headerModalStoreLocator.classList.remove('nf-store-is-selected');
    assignedStoreHeaderButton.textContent = originalAssignedStoreHeaderButtonContent;
    assignedStoreInput.disabled = false;
    assignedStoreInput.value = "";
    assignedStoreIdInput.value = "";
    headerStoreLocatorFormInnerHTML.classList.remove('col-12','col-lg-6');
    headerStoreLocatorFormInnerHTML.classList.add('col');
  }

  function resetSelectedStore(acknowledge = true) {
    persistSelectedStoreInformationLocal("", "");
    persistSelectedStoreInformationGlobal("");
    hideMySelectedStoreContent();

    if(acknowledge) {
      const resetStoreRegistrationFormEvent = new Event('resetStoreRegistrationForm');
      document.dispatchEvent(resetStoreRegistrationFormEvent);
    }
  }

  function onAssignedStoreInputKeydown(event) {
    if(event.key === "Enter"){
      event.stopPropagation();
      event.preventDefault();
    }
  }

  /**
   * Focus on Input by Button-Click
   * @type {Element}
   */
  let headerUpdateSelectedStoreButton = document.querySelector('#header_updateSelectedStore');
  let headerUpdateSelectedStoreButtonFormFieldInput = document.querySelector('#header_assigned_store');
  headerUpdateSelectedStoreButton.addEventListener('click',function(e){
    resetSelectedStore();
    headerUpdateSelectedStoreButtonFormFieldInput.focus();
  });

  document.addEventListener('updateStoreLocatorHeader', () => {
    preselectStore();
  });

  document.addEventListener('resetStoreHeaderForm', () => {
    resetSelectedStore(false);
  });

  /**
   * Close Modal by clicking outside of modal
   */
  function setButtonStateAndDimmer() {
    if (headerButtonModalStoreLocator.classList.contains('active')) {
      headerButtonModalStoreLocator.classList.remove('active')
      onModalCloseClick();
    } else {
      headerButtonModalStoreLocator.classList.add('active')
      onModalOpenClick();
    }
  }

  window.addEventListener('click', function (event) {
    if (headerModalStoreLocator.classList.contains("open") && event.target.parent.id != 'openHeaderStoreLocationDropdownButton') {
      if (! modalInnerContainer.contains(event.target)) {
        headerModalStoreLocator.classList.remove('open');
        setButtonStateAndDimmer();
      }
    }
  });

})(jQuery);
